// extracted by mini-css-extract-plugin
export var menuItem = "t_tv d_fZ d_bz d_bD d_bP d_bf";
export var menuItemSub = "t_tw d_Z d_bz d_bP";
export var menuMainLink = "t_tx d_f0 d_dB";
export var menuLink = "t_ty d_f0 d_dB";
export var icon = "t_p9 d_bC d_bP";
export var divider = "t_tz d_bC d_bP";
export var sublinks = "t_tB";
export var link = "t_mC";
export var Link = "t_rL q_rL q_qY q_rh";